import { render, staticRenderFns } from "./AddAcount.vue?vue&type=template&id=8cb1eb0a"
import script from "./AddAcount.vue?vue&type=script&lang=js"
export * from "./AddAcount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports